import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

import * as SiteActions from './site.actions';

import { SiteService } from '@core/api/site.service';
import { FormatHelperService } from '@core/helper/format-helper.service';
import { AppState } from '../index';

@Injectable()
export class SiteEffects {
  constructor(
    readonly actions$: Actions,
    readonly siteService: SiteService,
    public formatHelper: FormatHelperService,
    readonly router: Router,
    readonly store: Store<AppState>
  ) {}

  setActiveSite$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SiteActions.setActiveSite),
      concatMap(action => {
        return this.siteService.getSite(action.id).pipe(
          map(data => {
            const stands = data.versions.slice(-1)[0].stands;

            data.financials.stand_financials.forEach(stand_financial => {
              stands.forEach(stand => {
                if (stand.customId == stand_financial.custom_id) {
                  stand.pricingData = stand_financial;
                  stand.priceValuation = this.formatHelper.formatMinMaxValuation(
                    stand_financial.annual_valuation.map(obj => obj.valuation)
                  );
                }
              });
            });

            return SiteActions.setActiveSiteSuccess({ data });
          }),
          catchError(error => of(SiteActions.setActiveSiteFailure({ error })))
        );
      })
    );
  })
}
